import { connect } from 'react-redux';
import PapersMenuAdapter from './papers_menu_adapter';
import { setFrame, setWorkSize, setNonGlare } from '../../actions/canvas';

const mapPapersMenuAdapterProps = ({ workDetails, canvas: { works }, currentIndex }) => {
  const work = works[currentIndex] || {};
  const details = (work.workId ? workDetails[work.workId] : {}) || {};
  const {
    workSizeId, frameId, nonGlare, workId
  } = work;
  const {
    workSizes, thumbnails, currency, landscape
  } = details;

  return {
    workSizes,
    workSizeId,
    frameId,
    nonGlare,
    thumbnails,
    currency,
    landscape,
    workId,
    index: currentIndex
  };
};

export const ConnectedPapersMenuAdapter = connect(
  mapPapersMenuAdapterProps,
  (dispatch, ownProps) => ({
    setFrame: (frameId) => dispatch(setFrame(frameId, ownProps.index)),
    setWorkSize: (workSizeId) => dispatch(setWorkSize(workSizeId, ownProps.index)),
    setNonGlare: (value) => dispatch(setNonGlare(value, ownProps.index))
  })
)(PapersMenuAdapter);
